<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-modal-loading-screen *ngIf="isValidating">Validating Group</app-modal-loading-screen>
      <app-modal-loading-screen *ngIf="isDownloading">Preparing Template</app-modal-loading-screen>

      <div class="modal-header">
        <h4 class="pagetitle">Download PRF Template</h4>
        <span
          class="table-material-icons close-button"
          (click)="activeModal.dismiss('Cross click')"
          (keydown)="activeModal.dismiss('Cross click')"
          >close</span
        >
      </div>

      <div class="modal-body">
        <p class="options-label" *ngIf="!isCustomer">Select a template type</p>

        <div class="template-options" *ngIf="!isCustomer">
          <label
            class="template-option"
            [class.template-option--selected]="templateType === 'plain'"
          >
            <input
              type="radio"
              name="templateType"
              value="plain"
              [checked]="templateType === 'plain'"
              (change)="selectTemplateType('plain')"
            />
            <span class="template-option__text">
              <span class="template-option__title">Plain Template</span>
              <span class="template-option__subtitle">A blank PRF template with no group data.</span>
            </span>
          </label>

          <label
            class="template-option"
            [class.template-option--selected]="templateType === 'group'"
          >
            <input
              type="radio"
              name="templateType"
              value="group"
              [checked]="templateType === 'group'"
              (change)="selectTemplateType('group')"
            />
            <span class="template-option__text">
              <span class="template-option__title">Group Specific Template</span>
              <span class="template-option__subtitle"
                >Enter and validate a group to download its template.</span
              >
            </span>
          </label>
        </div>

        <div class="group-section" *ngIf="templateType === 'group'">
          <div class="PageLevelError" *ngIf="pageerror">{{ error }}</div>

          <div
            [ngClass]="{
              'has-error': groupcode.errors && (groupcode.touched || groupcode.dirty)
            }"
          >
            <label [ngClass]="'lib-text-field'" required>
              <input
                class="fullWidth"
                placeholder=" "
                [formControl]="groupcode"
                [readonly]="isValidating || isCustomer"
                (keyup)="validateGroup($event)"
                (mousedown)="validationclick()"
              />
              <span class="lib-placeholder">Group</span>

              <span
                class="help-block"
                *ngIf="groupcode.errors && (groupcode.touched || groupcode.dirty)"
              >
                <span *ngIf="groupcode.errors.required && istouched" class="inputMsg"
                  ><i class="table-material-icons">error</i> Group is required</span
                >
                <span *ngIf="groupcode.errors.pattern" class="inputMsg"
                  ><i class="table-material-icons">error</i> Please enter a valid Group</span
                >
              </span>
            </label>
          </div>

          <label [ngClass]="'lib-text-field'">
            <input readonly class="fullWidth" placeholder=" " [value]="groupname" />
          </label>
        </div>
      </div>

      <div class="modal-footer">
        <app-button
          size="medium"
          buttonType="secondary"
          (click)="activeModal.dismiss('Cancel')"
          (keydown)="activeModal.dismiss('Cancel')"
        >
          Cancel
        </app-button>
        <app-button
          size="medium"
          buttonType="primary"
          class="download-button"
          [disabled]="!canDownload || isDownloading"
          (click)="downloadTemplate()"
          (keydown)="downloadTemplate()"
        >
          Download Template
        </app-button>
      </div>
    </div>
  </div>
</div>
